import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/js/Style';
import Api from '../../Api';
import MenuPrimary from './MenuPrimary';
import MenuPopup from './MenuPopup';
import AdaptiveTrait from '../../AdaptiveTrait';
import MenuPrimaryDesktop from './MenuPrimaryDesktop';
import MenuSearchMobile from './MenuSearchMobile';
import Scroll from '../../Scroll';

export default class Menu extends React.Component {

    constructor(props) {

        super(props);

        this.scroll = new Scroll();

        // eslint-disable-next-line no-new
        new AdaptiveTrait(this, '1170px');

        this.headerElement = null;
        this.togglerElement = null;
        this.defaultTogglerHTML = null;
        this.dashboardButton = null;
        this.searchButton = null;
        this.closeTogglerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5.41406" y="4.00006" width="20" height="2" transform="rotate(45 5.41406 4.00006)" fill="#0F1011"/><rect x="4" y="18.1422" width="20" height="2" transform="rotate(-45 4 18.1422)" fill="#0F1011"/></svg>';

        this.state = {
            menu: null,
            headerHeight: 0,
            isMenuVisible: false,
            isSearchVisible: false,
        };
    }

    static get propTypes() {

        return {
            countryIso: PropTypes.string,
        };
    }

    componentDidMount() {

        const header = document.querySelector('body > header');
        if (header !== undefined) {

            const updateHeight = () => {

                const headerHeight = header.getBoundingClientRect().height;

                this.headerElement = header;
                this.headerElement.style.zIndex = 9999998;
                this.setState({ headerHeight });

                // eslint-disable-next-line curly
                if (this.state.isSearchVisible) {

                    // eslint-disable-next-line no-unused-expressions
                    AdaptiveTrait.isMobile()
                        ? this.scroll.disable()
                        : this.scroll.enable();
                }
            };

            updateHeight();

            AdaptiveTrait.addResizeEvent(() => updateHeight());

            const toggler = header.querySelector('[data-role="menu-toggler"]');
            if (toggler) {

                toggler.addEventListener('click', () => this.toggleMenu());

                this.togglerElement = toggler;
                this.defaultTogglerHTML = toggler.innerHTML;
            }

            const dashboardButton = header.querySelector('[data-role="menu-dashboard"]');
            if (dashboardButton)
                this.dashboardButton = dashboardButton;

            const searchButton = header.querySelector('[data-role="menu-search"]');
            if (searchButton) {

                searchButton.addEventListener('click', () => this.showSearch());
                this.searchButton = searchButton;
            }
        }

        Api
            .fetch(`/api/v2/menu.json?iso=${this.props.countryIso}`)
            .then((menu) => this.setState({ menu }));
    }

    renderMobile() {

        return (
            <>
                { this.renderMobileSearch() }
                { this.renderMobilePopup() }
            </>
        );
    }

    renderDesktop() {

        return (
            <>
                { this.renderDesktopSearch() }
                { this.renderDesktopPopup() }
            </>
        );
    }

    renderMobileSearch() {

        const { isSearchVisible, headerHeight } = this.state;

        if (!isSearchVisible)
            return null;

        return <MenuSearchMobile height={ headerHeight } onClose={ () => this.hideSearch() } />;
    }

    renderMobilePopup() {

        const { menu, isMenuVisible } = this.state;

        if (menu === null || !isMenuVisible)
            return null;

        return (
            <MenuPopup>
                { this.renderMenu() }
            </MenuPopup>
        );
    }

    renderDesktopSearch() {

        const { isSearchVisible, headerHeight } = this.state;

        if (!isSearchVisible)
            return null;

        return <MenuSearchMobile height={ headerHeight } onClose={ () => this.hideSearch() } />;
    }

    renderDesktopPopup() {

        const { menu } = this.state;

        if (menu === null)
            return null;

        return (
            <div className={ css('flex gap-lg px-6 h-full') }>
                { menu.map((props, index) => <MenuPrimaryDesktop key={ index } { ...props } />) }
            </div>
        );
    }

    renderMenu() {

        const { menu } = this.state;

        return menu.map((menuPrimaryProps, index) => <MenuPrimary key={ index } {...menuPrimaryProps} />);
    }

    toggleMenu() {

        const isMenuVisible = !this.state.isMenuVisible;

        this.setState({ isMenuVisible }, () => {

            if (isMenuVisible) {

                if (AdaptiveTrait.isMobile())
                    this.scroll.disable();

                this.togglerElement.innerHTML = this.closeTogglerHTML;

                if (this.dashboardButton)
                    this.dashboardButton.classList.add(css('hidden'));

                if (this.searchButton)
                    this.searchButton.classList.add(css('hidden'));
            }
            else {

                this.scroll.enable();

                this.togglerElement.innerHTML = this.defaultTogglerHTML;

                if (this.dashboardButton)
                    this.dashboardButton.classList.remove(css('hidden'));

                if (this.searchButton)
                    this.searchButton.classList.remove(css('hidden'));
            }
        });
    }

    showSearch() {

        if (AdaptiveTrait.isMobile())
            this.scroll.disable();

        this.setState({ isSearchVisible: true });
    }

    hideSearch() {

        this.scroll.enable();
        this.setState({ isSearchVisible: false });
    }

}